import { PageLayout } from "@/components/layout/page-layout";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Rss } from "lucide-react";

export default function BlogIndex() {
  return (
    <PageLayout breadcrumbs={[{ label: "Blog" }]}>
      <div className="mb-8">
        <Badge variant="secondary" className="mb-4">Blog</Badge>
        <h1 className="text-4xl font-extrabold tracking-tight mb-4">LoadLogo Blog</h1>
        <p className="text-lg text-secondary-foreground max-w-2xl leading-relaxed">
          Tutorials, product updates, and insights about logo APIs, brand data, and building better developer tools.
        </p>
      </div>

      <div className="bg-card border rounded-2xl py-16 px-8 text-center">
        <div className="w-12 h-12 bg-warm-lavender-bg border border-warm-lavender rounded-xl flex items-center justify-center mx-auto mb-5">
          <Rss className="w-6 h-6 text-primary" />
        </div>
        <h2 className="text-2xl font-extrabold tracking-tight mb-3">Coming soon</h2>
        <p className="text-sm text-secondary-foreground max-w-md mx-auto mb-6 leading-relaxed">
          We're working on tutorials, integration guides, and product updates.
          In the meantime, check out our API documentation to get started.
        </p>
        <div className="flex gap-3 justify-center flex-wrap">
          <Button size="lg" asChild>
            <a href="/docs">Read the Docs</a>
          </Button>
          <Button variant="outline" size="lg" asChild>
            <a href="mailto:hello@loadlogo.com">Get Notified</a>
          </Button>
        </div>
      </div>
    </PageLayout>
  );
}
